import React from 'react';
import { methodSteps } from '../data/landing';
export function BonusSection() {
  return <section aria-labelledby="bonus" className="bg-ink text-cream" data-id="element-38" data-mp="1og3zv1bnuj5n">
      
    </section>;
}